import { ReviewerType } from '../../../enums';

export const REVIEWERS_TITLES: Record<ReviewerType, string> = {
  [ReviewerType.Student]: 'Élève',
  [ReviewerType.Parent]: 'Parent ou famille',
  [ReviewerType.Employer]: 'Employeur',
  [ReviewerType.MissionLocale]: 'Mission locale',
  [ReviewerType.EmploymentCenter]: 'Pôle emploi',
  [ReviewerType.Depository]: 'Caisse des dépôts',
  [ReviewerType.Other]: 'Autre financeur',
};
